import React from 'react';

/**
 * Lightweight CSS phone-device mockup used to preview invitation cards the
 * way a guest would see them on a mobile screen.
 */
const PhoneFrame = ({ children }) => (
  <div className="mx-auto" style={{ width: 220 }}>
    <div className="relative rounded-[2rem] bg-gray-900 p-2 shadow-xl">
      <div className="absolute left-1/2 -translate-x-1/2 top-2 w-16 h-3 bg-gray-900 rounded-full z-10" />
      <div className="rounded-[1.5rem] overflow-hidden bg-white aspect-[9/19]">{children}</div>
    </div>
  </div>
);

export default PhoneFrame;
